import ResponsiveContainer from '../../../layouts/ResponsiveContainer'
import CustomSelects, { CustomSelectsOption } from '../../../components/Inputs/Selects/CustomSelect'
import Evaluations from '../../../components/Evaluations/Evaluations'
import { ArithmeticalEvaluation } from '../../../interfaces/Evaluations'
import Loading from '../../../components/Loading/Loading'

interface IEvaluationCard {
    arithmeticalEvaluation: ArithmeticalEvaluation[]
    periodOptions: CustomSelectsOption[]
    defaultSelectedItemSelect: string,
    trivalent_evaluation_right: -1 | 0 | 1 | 2 | null
    onSelectPeriod: (value: string) => void
    selectedPeriod: string
    loading: "idle" | "pending" | "succeeded" | "failed";
}

const EvaluationCard = ({
    arithmeticalEvaluation,
    periodOptions,
    defaultSelectedItemSelect,
    trivalent_evaluation_right,
    onSelectPeriod,
    selectedPeriod,
    loading
}: IEvaluationCard) => {
    return (
        <ResponsiveContainer
            className='bg-primary-100 relative z-[345] evaluation-and-filter-card top-[13.75rem] md:top-[10.375rem] lg:top-40 p-8 rounded-lg shadow-custom-dual flex flex-col gap-4 mt-6'
        >
            <div className='w-[160px] flex items-end gap-2'>
                <CustomSelects
                    label=''
                    options={periodOptions}
                    onSelect={onSelectPeriod}
                    selectedItem={selectedPeriod}
                    defaultSelectedItem={defaultSelectedItemSelect}
                    showLabel={false}
                />
                {
                    loading === 'pending'
                        ? <Loading size={26} />
                        : null
                }
            </div>
            <Evaluations
                arithmeticalEvaluation={arithmeticalEvaluation}
                showArithmeticalIndicators={true}
                arithmeticalEvaluationLabel='Cantidad de indicadores por estado evaluados'
                trivalentEvaluation={trivalent_evaluation_right}
                trivalentStateStyle='text-bmedium md:text-llarge text-brand-green-15 md:text-system-ligth-40 md:text-primary-10'
                evaluationStyle='text-hsmall'
                backgroundColorCard='#F6F8F8'
                showTitleEvaluation={true}
                labelArithmeticalEvaluationStyle='text-bmedium md:text-llarge text-brand-green-15 md:text-system-ligth-40 md:text-primary-10 text-left md:text-center mb-3 md:mb-0'
            />
        </ResponsiveContainer>
    )
}

export default EvaluationCard